// Module
var code = "<div data-test-name=\"loading\" class=\"loading fa-2x\">\n  <i class=\"icon fa fa-fw fa-spin fa-cog\"></i>\n  <span data-bind=\"text: loadingText\"></span>\n</div>\n";
// Exports
module.exports = code;